// @flow
import type { Action } from './types';

export const analyticsBingeWatchingPlayNextOrCancelSelected = (
  isCanceled: boolean,
  franchiseName: string,
  episodeName: string,
  seasonNumber: string,
  episodeNumber: string,
  timeLeft: number,
): Action => ({
  type: 'ANALYTICS_BINGE_WATCHING_PLAY_NEXT_OR_CANCEL_SELECTED',
  isCanceled,
  franchiseName,
  episodeName,
  seasonNumber,
  episodeNumber,
  timeLeft,
});

export const analyticsBingeWatchingNoUserAction = (
  franchiseName: string,
  episodeName: string,
  seasonNumber: string,
  episodeNumber: string,
): Action => ({
  type: 'ANALYTICS_BINGE_WATCHING_NO_USER_ACTION',
  franchiseName,
  episodeName,
  seasonNumber,
  episodeNumber,
});

export const analyticsNumberOfContinuousEpisodesWatched = (
  networkName: string,
  eventName: string,
  count: number,
): Action => ({
  type: 'ANALYTICS_NUMBER_OF_CONTINUOUS_EPISODES_WATCHED',
  networkName,
  eventName,
  count,
});
